<template>
  <div>
    <div class="box"></div>
    <div class="box2">
      <div class="lef">
        <div>工程动画</div>
        <p v-for="item in menuList" :key="item.id">
          <a :class="item.id==code? 'don':''" @click="menuClick(item.id)">· {{ item.title }}</a>
        </p>
      </div>
      <div v-if="dataList" class="rit">
        <p class="tit">{{ dataList.title }}</p>
        <div class="vid">
          <iframe :src="dataList.url" width="100%" height="100%" frameborder="0" allowFullScreen></iframe>
        </div>
        <div class="txt" v-html="dataList.text"></div>
        <div class="but">
          <span class="l" @click="upClick(dataList.id)">上一篇</span>
          <span class="r" @click="nextClick(dataList.id)">下一篇</span>
        </div>
      </div>
      <div v-else class="prop">暂时没有内容~</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NewsCeter",
  data() {
    return {
      code: sessionStorage.getItem('carCode2'),
      dataList: {},
      menuList: [
        {
          id: 1,
          title: '景成大厦项目施工动画演示',
          url: 'https://player.youku.com/embed/XNDA5MDEyMzY3Mg==',
          text: '景成大厦项目地处昆明市巫家坝开发片区，拟建城市新中心核心位置，西邻飞虎大道、南邻春城路[标注为：飞虎大道（拟建）、春城路（拟建）]，占地面积约2.1万平方米，总建筑面积24.34万平方米。由1栋超高层建筑与商业建筑组成。地下室4层（局部5层），地上裙楼6层、高度37.45米，塔楼57层、高度268.8米。建筑功能集写字楼、酒店、商业为一体。'
        },
        {
          id: 2,
          title: '合肥工业大学智能制造技术研究院研发中心工程',
          url: 'https://player.youku.com/embed/XNDA5MDEyMTM3Mg==',
          text: '本工程位于滨湖卓越城，花园大道以南、辽宁路以东、西安路以北、泰山路以西围合区域的内部。总建筑面积约 18.8万平米，地下一层，5.1万平米，地上五层，13.7万平米，基础结构形式为筏板加柱墩；地上结构形式框架结构加局部钢框架结构，钢结构部分最大单跨约 42 米。'
        },
        {
          id: 3,
          title: 'PAVILION',
          url: 'https://player.youku.com/embed/XNDA5MDExNDQ3Mg==',
          text: 'PAVILION DAMANSARA HEIGHETS为白沙罗高地（DAMANSARA HEIGHTS）新的的大都市。（是）PAVILION集团投资兴建的另一项杰出工程。本项目包含奢华住宅、办公大楼及优质购物中心。<br>' +
              '奢华住宅区包含3栋塔楼，建筑面积195,293㎡。优质购物中心：从LG到第三层，共5层。层高5.5m。3M层为设备夹层，层高为4.5m。地下室车库，从B8到B1，共8层，层高3.3m。'
        },
        {
          id: 4,
          title: '深圳机场卫星厅及其配套工程建造演示',
          url: 'https://player.youku.com/embed/XNDA5MDEyNDkyNA==',
          text: '【片头】海上丝绸之路，穿过历史的风雨，承载着新的期待，大湾区经济圈、深圳大空港宏伟规划催人奋进，创新的风帆，丰满的羽翼，一座章鱼造型的卫星厅即将展翅起航，奔赴新时代！<br>' +
              '深圳机场卫星厅及其配套工程项目位于宝安T3国际机场航站楼北侧，包括旅客卫星厅、T3适应性改造、旅客捷运系统、行李隧道、北区配套工程。场内分布已运营地铁11号线、在建穗莞深城际铁路和拟建深茂城际铁路，共有3条下穿隧道。建成后将与T3航站楼共同承担旅客吞吐量5200万人次任务，结合我单位机场系列工程的成功施工经验。'
        }
      ]
    }
  },
  methods: {
    menuClick(id) {
      if (this.code !== id) {
        this.code = id;
        this.dataList = this.menuList[this.code - 1];
        sessionStorage.setItem('carCode2', id);
      }
    },
    upClick(id) {
      if (id !== 1) {
        this.code = id - 1;
        this.dataList = this.menuList[this.code - 1];
        sessionStorage.setItem('carCode2', id - 1);
      }

    },
    nextClick(id) {
      let count = this.menuList.length;
      if (id !== count) {
        this.code = id + 1;
        this.dataList = this.menuList[this.code - 1];
        sessionStorage.setItem('carCode2', id + 1);
      }
    }
  },
  mounted() {
    this.dataList = this.menuList[this.code - 1];
    document.documentElement.scrollTop = 0;
  }
}
</script>

<style lang="scss" scoped>
.box {
  height: 2.9rem;
  width: 100%;
  background: url("./img/banner/3.jpg");
  background-size: 100% 100%;
}

.box2 {
  width: 12rem;
  margin: .6rem auto 0;
  display: flex;

  .lef {
    width: 2.5rem;
    overflow: hidden;

    div {
      font-size: .2rem;
      position: relative;
      padding-left: .1rem;
      margin-bottom: .19rem;
    }

    div::before {
      position: absolute;
      content: "";
      left: 0rem;
      top: .06rem;
      background: #E70F20;
      width: 2px;
      height: .16rem;
    }

    p {
      line-height: .34rem;
      font-size: .16rem;
      width: 2.5rem;
      color: #3F3F3F;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      cursor: pointer;

      a {
        display: inline-block;
        width: 100%;
      }
    }

    .don {
      color: #E70F20
    }
  }

  .rit {
    margin-left: .15rem;
    border-left: 1px solid #E5E5E5;
    padding-left: .85rem;
    width: 10.07rem;

    p.tit {
      width: 5.7rem;
      font-size: .26rem;
      text-align: center;
      margin: 0 auto;
      line-height: .41rem;
      letter-spacing: 1px;
    }

    div.vid {
      margin: .58rem auto 0;
      width: 7rem;
      height: 3.94rem;
    }

    div.txt {
      margin-top: .44rem;
      line-height: .36rem;
      color: #595757;
      font-size: .18rem;
      text-align: justify;
    }

    div.but {
      text-align: center;
      margin-top: .56rem;

      span {
        width: 69px;
        height: 26px;
        line-height: 29px;
        display: inline-block;
        font-size: 12px;
        margin: 0 .25rem;
        cursor: pointer;
      }

      .l {
        background: url("../../assets/images/pg.png");
        background-size: 100% 100%;
        padding-left: .07rem
      }

      .r {
        background: url("../../assets/images/pg2.png");
        background-size: 100% 100%;
        padding-right: .07rem
      }
    }
  }

  .prop {
    width: 10rem;
    font-size: .26rem;
    color: #ddd;
    text-align: center;
    padding-top: 1rem;
  }
}
</style>
